<template>
  <section class="merge-request-item-merge-area-form">
    <div class="form-group">
      <label
        class="font-weight-bold"
        for="commitMergeMessage"
      >
        {{ $t('labelMergeCommitField') }}
      </label>
      <textarea
        id="commitMergeMessage"
        v-model="form.mergeMessage"
        rows="4"
        class="form-control form-control-sm"
        type="text"
        :disabled="isDisabledField"
        inputmode="text"
        :placeholder="$t('labelMergeCommitField')"
      ></textarea>
    </div>

    <div
      v-if="isSquashCommit"
      class="form-group"
      :class="{ 'mb-0': !showSquashField }"
    >
      <label class="gf-custom-checkbox w-100">
        <input
          v-model="showSquashField"
          type="checkbox"
        />
        <span>
          {{ $t('enableSquashCommit') }}
        </span>
      </label>

            <div v-if="showSquashField">
                <label
                    class="font-weight-bold"
                    for="commitMergeMessage"
                >
                    {{ $t('labelSquashCommitField') }}
                </label>
                <textarea
                    id="commitMergeMessage"
                    v-model="form.squashMessage"
                    rows="4"
                    class="form-control form-control-sm"
                    type="text"
                    :disabled="isDisabledField"
                    inputmode="text"
                    :placeholder="$t('labelMergeCommitField')"
                ></textarea>
                <small class="text-muted">{{ $t('infoSquashCommit') }}</small>
            </div>
        </div>
        <div class="merge-request-item-form">

      <div class="merge-request-item-form__buttons">
        <button
          type="button"
          class="btn btn-dark btn-sm m-1"
          @click="cancelCommit"
        >
          {{ $t('cancelMergeCommit') }}
        </button>
        <button
          type="button"
          class="btn btn-success btn-sm m-1"
          :disabled="isSubmitDisabled"
          @click="sendCommit"
        >
          {{ $t('CONFIRMED') }}
        </button>
      </div>
    </div>
  </section>
</template>
<script>
import mergeRequestMessages from '@shared/modules/merge-request/mergeRequestMessages';

export default {
  name: 'MergeRequestItemMergeAreaForm',
  props: {
    mergeMessage: {
      type: String,
      request: true
    },
    squashMessage: {
      type: String,
      request: true
    },
    disabledField: {
      type: Boolean,
      request: true
    },
    isSquashCommit: {
      type: Boolean,
      request: true
    }
  },
  data() {
    return {
      form: {
        mergeMessage: '',
        squashMessage: ''
      },
      showSquashField: false,
      isSubmitDisabled: false
    };
  },
  computed: {
    isDisabledField() {
      return !this.disabledField;
    }
  },
  mounted() {
    this.form.mergeMessage = this.mergeMessage;
    this.form.squashMessage = this.squashMessage;
  },
  methods: {
    cancelCommit() {
      this.$emit('close');
    },
    sendCommit() {
      if (this.isSquashCommit && !this.showSquashField) {
        this.form.squashMessage = this.squashMessage;
      }
      this.isSubmitDisabled = true;
      this.$emit('send', this.form);
    },
    enableSubmitButton() {
      this.isSubmitDisabled = false;
    }
  },
  i18n: {
    messages: mergeRequestMessages
  }
};
</script>
<style lang="scss">
$this: '.merge-request-item-form';

#{$this} {
    #{$this}__buttons {
        display: flex;
        justify-content: end;
    }
}
</style>
